const VIDEO_PMP_IMPRESSION_TYPE = {
    VIDEO: 'VIDEO',
    NATIVE_VIDEO: 'NATIVE',
};

export default VIDEO_PMP_IMPRESSION_TYPE;
